import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Contact_C2_C4 from "../components/Documents/contract_C2_C4";
import Contact_C5_C9 from "../components/Documents/contract_C5_C9";
import Contact_C7_C9 from "../components/Documents/contract_C7_C9";
import Contact_Parttime_C5_C9 from "../components/Documents/contract_parttime_C5_C9";
import Contact_Parttime_C7_C9 from "../components/Documents/contract_parttime_C7_C9";
import Contract_Secret from "../components/Documents/contract_secret";
import HRM_013 from "../components/Documents/hrm_013";
import HRM_022 from "../components/Documents/hrm_022";
import HRM_040 from "../components/Documents/hrm_040";
import HRM_054 from "../components/Documents/hrm_054";
import HRM_068 from "../components/Documents/hrm_068";
import Salary_Deduction from "../components/Documents/salary_deductions";
import Warning_Corruption from "../components/Documents/warning_corruption";
import DB7_1Year from "../components/Documents/DB7_1Year";
import DB7_2Year from "../components/Documents/DB7_2Year";
import DB7_Last from "../components/Documents/DB7_Last";
import Success_contract_office from "../components/Documents/Success_contract_office"
import Success_contract_branch from "../components/Documents/Success_contract_branch"
import Bakery_C5_C9 from "../components/Documents/bakery_C5_C9";
import Bakery_Suit from "../components/Documents/bakery_suit";
import Bakery_Social from "../components/Documents/bakery_social";
import Bakery_Secret from "../components/Documents/bakery_secret";
import { contactAPI } from "../services/ContactAPI";
import { authAPI } from "../services/AuthAPI";
import { imageURL } from "../utils/config";
import moment from "moment";
import "./export_docs.css";

const Export_Docs = ({ isMobile, closeNav }) => {
  const pdfExportComponent = useRef(null);
  const [doc, setDoc] = useState("");
  const [data, setData] = useState(null);
  const [emp_code, setEmp_Code] = useState("");
  const [loading, setLoading] = useState(false);
  const [all, setAll] = useState([]);
  const [select, setSelect] = useState("");

  const print = useCallback(() => {
    pdfExportComponent.current.save();
  }, [pdfExportComponent.current, data]);

  useEffect(() => {
    setDoc("");
    setEmp_Code("");
  }, [select]);

  useEffect(() => {
    authAPI
      .getPrefix()
      .then((res) => {
        if (res.status == 200) {
          setAll(res.message);
        }
      })
      .catch((error) => {
        alert(error.message);
      });
  }, []);
  const detail_company = [
    {
      name: "Com7",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
    },
    {
      name: "Double7",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_db7.jpg`,
      foot: `${imageURL}/header_footer/foot_db7.jpg`,
    },
    {
      name: "SeeKnowHow",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_skh.jpg`,
      foot: `${imageURL}/header_footer/foot_skh.jpg`,
    },
    {
      name: "ThunderFinFin",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_thunder.jpg`,
      foot: `${imageURL}/header_footer/foot_thunder.jpg`,
    },
    {
      name: "ADEPT",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_adept.jpg`,
      foot: `${imageURL}/header_footer/foot_adept.jpg`,
    },
    {
      name: "ITEC",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_itec.jpg`,
      foot: `${imageURL}/header_footer/foot_itec.jpg`,
    },
    {
      name: "Bakery",
      address: "เลขที่ 222 ถนนเทพรัตน แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_bakery.jpg`,
      foot: `${imageURL}/header_footer/foot_bakery.jpg`,
    },
    {
      name: "SuccessMarch",
      address: "1104/260 ถนนพัฒนาการ แขวงสวนหลวง เขตสวนหลวง กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_successmarch.jpg`,
    },
    {
      name: "ClubSuccess",
      address: "1104/260 ถนนพัฒนาการ แขวงสวนหลวง เขตสวนหลวง กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_clubSuccess.jpg`,
    },
    {
      name: "Organic",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_organic.jpg`,
    },
    {
      name: "Intervision",
      address: "549/1 ถนนสรรพาวุธ แขวงบางนาใต้ เขตบางนา กรุงเทพมหานคร",
      head: `${imageURL}/header_footer/head_intervision.jpg`,
      foot: `${imageURL}/header_footer/foot_intervision.jpg`,
    },
  ];

  const CompanyData = useMemo(
    () =>
      all.find((res) => res.org_name == select) instanceof Object
        ? all.find((res) => res.org_name == select)
        : {},
    [select]
  );

  const CompanyDetail = useMemo(
    () =>
      detail_company.find((res) => res.name == select) instanceof Object
        ? detail_company.find((res) => res.name == select)
        : {},
    [select]
  );

  const DocsData = useMemo(() => (data instanceof Object ? data : {}), [data]);
  const changeTitle = useMemo(() => {
    switch (doc) {
      case "HRM_013":
        return "แบบฟอร์มประกาศเรื่องการดำเนินการกับพนักงานที่ทุจริต";
      case "HRM_022":
        return "การลงโปรแกรม Software ในผลิตภัณฑ์ของ Apple";
      case "HRM_040":
        return "เอกสารห้ามลงโปรแกรมละเมิดลิขสิทธิ์";
      case "HRM_054":
        return "ข้อห้ามใช้เครื่องหมายการค้าและเปิดเผยข้อมูลผ่าน Social Network";
      case "HRM_068":
        return "เอกสารยืนยันการตรวจสอบสมุดบัญชีธนาคารเพื่อรับเงินเดือนหรือค่าจ้างของพนักงาน";
      case "Salary_Deduction":
        return "หนังสือยินยอมให้หักเงิน";
      case "Warning_Corruption":
        return "หนังสือแจ้งเตือนป้องปราบการทุจริตของพนักงาน";
      case "DB7_1Year":
        return "DB7 สัญญาจ้างพนักงานแบบรายปีแรก";
      case "DB7_2Year":
        return "DB7 สัญญาจ้างพนักงานแบบรายปี ปีที่ 2";
      case "DB7_Last":
        return "เอกสารแนบท้ายสัญญาจ้าง";
      case "Success_contract_office":
        return "สัญญาจ้างแบบประจำ Office";
      case "Success_contract_branch":
        return "สัญญาจ้างแบบประจำ หน้าร้าน";
      case "Bakery_Secret":
        return "สัญญารักษาข้อมูลทางการค้า";
      case "Bakery_Suit":
        return "หนังสือยินยอมหักค่าชุดทำงาน";
      default:
        return doc;
    }
  }, [doc]);
  const handleChange = (event) => {
    setDoc(event.target.value);
  };

  useEffect(() => {
    setData(null);
  }, [doc]);

  const allowFile = [
    {
      name: "สัญญาจ้าง C1-C4",
      show: "สัญญาจ้าง C1-C4",
      allow: ["Com7", "Double7","ADEPT", "ThunderFinFin", "Bakery"],
    },
    {
      name: "สัญญาจ้าง C5-C9",
      show: "สัญญาจ้าง C5-C9",
      allow: [
        "Com7",
        "Double7",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "Bakery_C5_C9",
      show: "สัญญาจ้าง C5-C9",
      allow: ["Bakery"],
    },
    {
      name: "สัญญาจ้าง C7-C9 (สำหรับหน้าร้าน)",
      show: "สัญญาจ้าง C7-C9 (สำหรับหน้าร้าน)",
      allow: ["Com7"],
    },
    {
      name: "สัญญาจ้าง 3-6เดือน,รายปี C5-C9",
      show: "สัญญาจ้าง 3-6เดือน,รายปี C5-C9",
      allow: ["Com7", "Double7", "SeeKnowHow", "ThunderFinFin", "ADEPT"],
    },
    {
      name: "สัญญาจ้าง 3-6เดือน,รายปี C7-C9 (สำหรับหน้าร้าน)",
      show: "สัญญาจ้าง 3-6เดือน,รายปี C7-C9 (สำหรับหน้าร้าน)",
      allow: ["Com7"],
    },
    {
      name: "DB7_1Year",
      show: "DB7 สัญญาจ้างพนักงานแบบรายปีแรก",
      allow: ["Double7"],
    },
    {
      name: "DB7 สัญญาจ้างพนักงานแบบรายปี ปีที่ 2",
      show: "DB7 สัญญาจ้างพนักงานแบบรายปี ปีที่ 2",
      allow: ["Double7"],
    },
    {
      name: "HRM_013",
      show: "แบบฟอร์มประกาศเรื่องการดำเนินการกับพนักงานที่ทุจริต",
      allow: [
        "Com7",
        "Double7",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "HRM_022",
      show: "การลงโปรแกรม Software ในผลิตภัณฑ์ของ Apple",
      allow: [
        "Com7",
        "Double7",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "HRM_040",
      show: "เอกสารห้ามลงโปรแกรมละเมิดลิขสิทธิ์",
      allow: [
        "Com7",
        "Double7",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "HRM_054",
      show: "ข้อห้ามใช้เครื่องหมายการค้าและเปิดเผยข้อมูลผ่าน Social Network",
      allow: [
        "Com7",
        "Double7",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "HRM_068",
      show: "เอกสารยืนยันการตรวจสอบสมุดบัญชีธนาคารเพื่อรับเงินเดือนหรือค่าจ้างของพนักงาน",
      allow: [
        "Com7",
        "Double7",
        "Bakery",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "Salary_Deduction",
      show: "หนังสือยินยอมให้หักเงิน",
      allow: [
        "Com7",
        "Double7",
        "Bakery",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "Warning_Corruption",
      show: "หนังสือแจ้งเตือนป้องปราบการทุจริตของพนักงาน",
      allow: [
        "Com7",
        "Double7",
        "Bakery",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "สัญญารักษาความลับทางการค้า",
      show: "สัญญารักษาความลับทางการค้า",
      allow: [
        "Com7",
        "Double7",
        "Bakery",
        "SeeKnowHow",
        "ThunderFinFin",
        "ADEPT",
        "ITEC",
      ],
    },
    {
      name: "DB7_Last",
      show: "เอกสารแนบท้ายสัญญาจ้าง",
      allow: ["Double7"],
    },
    {
      name: "Success_contract_office",
      show: "สัญญาจ้างแบบประจำ Office",
      allow: ["SuccessMarch","ClubSuccess","Organic","Intervision"],
    },
    {
      name: "Success_contract_branch",
      show: "สัญญาจ้างแบบประจำ หน้าร้าน",
      allow: ["SuccessMarch","ClubSuccess"],
    },
    {
      name: "Bakery_Suit",
      show: "หนังสือยินยอมหักค่าชุดทำงาน",
      allow: ["Bakery"],
    },
    {
      name: "Bakery_Social",
      show: "หนังสือรับทราบการใช้ช้อมูลของบริษัทในสื่อออนไลน์ต่างๆ",
      allow: ["Bakery"],
    },
    {
      name: "Bakery_Secret",
      show: "สัญญารักษาข้อมูลทางการค้า",
      allow: ["Bakery"],
    },
  ];

  const checkDoc = useMemo(() => {
    switch (doc) {
      case "สัญญาจ้าง C5-C9":
        return "normal";
      case "สัญญาจ้าง C1-C4":
        return "normal"
      case "Bakery_C5_C9":
        return "normal";
      case "สัญญาจ้าง C7-C9 (สำหรับหน้าร้าน)":
        return "normal";
      case "สัญญาจ้าง 3-6เดือน,รายปี C5-C9":
        return "contract";
      case "สัญญาจ้าง 3-6เดือน,รายปี C7-C9 (สำหรับหน้าร้าน)":
        return "contract";
      case "DB7_1Year":
        return "contract";
      case "DB7 สัญญาจ้างพนักงานแบบรายปี ปีที่ 2":
        return "contract";
      case "Success_contract_office":
        return "normal";
      case "Success_contract_branch":
        return "normal";  
      case "Bakery_Suit":
        return "detail";
      case "Bakery_Social":
        return "detail";
      case "Bakery_Secret":
        return "detail";
      default:
        return "detail";
    }
  }, [doc]);

  const ChangeMonth = (key) => {
    switch (key) {
      case 1:
        return "มกราคม";
      case 2:
        return "กุมภาพันธ์";
      case 3:
        return "มีนาคม";
      case 4:
        return "เมษายน";
      case 5:
        return "พฤษภาคม";
      case 6:
        return "มิถุนายน";
      case 7:
        return "กรกฎาคม";
      case 8:
        return "สิงหาคม";
      case 9:
        return "กันยายน";
      case 10:
        return "ตุลาคม";
      case 11:
        return "พฤศจิกายน";
      case 12:
        return "ธันวาคม";
      default:
        return "";
    }
  };

  const searchAPI = async () => {
    try {
      setLoading(true);
      let find = all.find((res) => res.org_name == select);
      const { status, message } = await contactAPI.getContact({
        empcode: emp_code,
        company: find.prefix || "com7",
        type: checkDoc,
      });
      if (status != 200) throw { message };
      if (!message[0] instanceof Object)
        throw { message: "message is not Object." };
      let newObj = { ...message[0] };
      if (newObj.detail_salary) {
        newObj.detail_salary = newObj.detail_salary.toString();
        newObj.detail_salary = newObj.detail_salary.replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1,"
        );
      }
      newObj.date_day = Number(moment().format("DD"));
      newObj.date_month = ChangeMonth(Number(moment().format("MM")));
      newObj.date_year = Number(moment().format("YYYY")) + 543;

      if (newObj.StartDate) {
        newObj.detail_start_date_day = Number(
          moment(newObj.StartDate).format("DD")
        );
        newObj.detail_start_date_month = ChangeMonth(
          Number(moment(newObj.StartDate).format("MM"))
        );
        newObj.detail_start_date_year =
          Number(moment(newObj.StartDate).format("YYYY")) + 543;
        if (checkDoc == "detail") {
          let date = Number(moment(newObj.StartDate).format("DD"));
          let month = ChangeMonth(
            Number(moment(newObj.StartDate).format("MM"))
          );
          let year = Number(moment(newObj.StartDate).format("YYYY")) + 543;
          newObj.detail_start_date = `${date} ${month} ${year}`;
          newObj.personal_info_id = emp_code;
        }
      }

      if (newObj.IdentityCardExpire) {
        if (checkDoc == "detail") {
          let date = Number(moment(newObj.IdentityCardExpire).format("DD"));
          let month = ChangeMonth(
            Number(moment(newObj.IdentityCardExpire).format("MM"))
          );
          let year = Number(moment(newObj.IdentityCardExpire).format("YYYY")) + 543;
          newObj.IdentityCardExpire_setDate = `${date} ${month} ${year}`;
        }
      }

      if (newObj.ContractStartDate) {
        newObj.detail_contract_start_date_day = Number(
          moment(newObj.ContractStartDate).format("DD")
        );
        newObj.detail_contract_start_date_month = ChangeMonth(
          Number(moment(newObj.ContractStartDate).format("MM"))
        );
        newObj.detail_contract_start_date_year =
          Number(moment(newObj.ContractStartDate).format("YYYY")) + 543;
      }
      if (newObj.ContractEndDate) {
        newObj.detail_contract_end_date_day = Number(
          moment(newObj.ContractEndDate).format("DD")
        );
        newObj.detail_contract_end_date_month = ChangeMonth(
          Number(moment(newObj.ContractEndDate).format("MM"))
        );
        newObj.detail_contract_end_date_year =
          Number(moment(newObj.ContractEndDate).format("YYYY")) + 543;
      }
      setData(newObj);
      setLoading(false);
    } catch (error) {
      alert(error.message);
      setLoading(false);
    }
  };

  const SelectDocs = useMemo(() => {
    switch (doc) {
        case "สัญญาจ้าง C1-C4":
        return (
          <Contact_C2_C4
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "สัญญาจ้าง C5-C9":
        return (
          <Contact_C5_C9
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Bakery_C5_C9":
        return (
          <Bakery_C5_C9
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "สัญญาจ้าง C7-C9 (สำหรับหน้าร้าน)":
        return (
          <Contact_C7_C9
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "สัญญาจ้าง 3-6เดือน,รายปี C5-C9":
        return (
          <Contact_Parttime_C5_C9
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "สัญญาจ้าง 3-6เดือน,รายปี C7-C9 (สำหรับหน้าร้าน)":
        return (
          <Contact_Parttime_C7_C9
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "สัญญารักษาความลับทางการค้า":
        return (
          <Contract_Secret
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "HRM_013":
        return (
          <HRM_013
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "HRM_022":
        return (
          <HRM_022
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "HRM_040":
        return (
          <HRM_040
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "HRM_054":
        return (
          <HRM_054
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "HRM_068":
        return (
          <HRM_068
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Salary_Deduction":
        return (
          <Salary_Deduction
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Warning_Corruption":
        return (
          <Warning_Corruption
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "DB7_1Year":
        return (
          <DB7_1Year
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "DB7 สัญญาจ้างพนักงานแบบรายปี ปีที่ 2":
        return (
          <DB7_2Year
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "DB7_Last":
        return (
          <DB7_Last
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Success_contract_office":
        return (
          <Success_contract_office
          pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Success_contract_branch":
          return (
            <Success_contract_branch
            pdfExportComponent={pdfExportComponent}
              data={DocsData}
              company={CompanyData}
              company2={CompanyDetail}
            />
      );
      case "Bakery_Suit":
        return (
          <Bakery_Suit
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Bakery_Social":
        return (
          <Bakery_Social
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      case "Bakery_Secret":
        return (
          <Bakery_Secret
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
      default:
        return (
          <Contact_C2_C4
            pdfExportComponent={pdfExportComponent}
            data={DocsData}
            company={CompanyData}
            company2={CompanyDetail}
          />
        );
    }
  }, [doc, DocsData]);

  return (
    <>
      <div
        className="container h-100vh"
        style={{
          display: closeNav ? "block" : isMobile ? "none" : "block",
          marginTop: !isMobile ? 0 : "70px",
          justifyContent: "flex-end",
          padding: !isMobile ? "none" : "0",
        }}
      >
        <div style={{ display: "flex", height: "97vh" }}>
          <div style={{ width: "30%" }}>
            <div className="control_center">
              <h1 className="title">{changeTitle}</h1>
              <div className="doc_select">
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    font: "200%",
                  }}
                >
                  เลือกบริษัท {select}
                </div>
                <Select
                  value={select}
                  onChange={(e) => setSelect(e.target.value)}
                  className="select_box"
                >
                  {all.map((res, i) => (
                    <MenuItem key={i} value={res.org_name}>
                      {res.name_th}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              {select && (
                <div className="doc_select">
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      font: "200%",
                    }}
                  >
                    เลือกประเภทเอกสาร
                  </div>

                  <Select
                    value={doc}
                    onChange={handleChange}
                    className="select_box"
                  >
                    {allowFile
                      .filter((res) => res.allow.find((rez) => rez == select))
                      .map((res) => (
                        <MenuItem key={res.name} value={res.name}>
                          {res.show}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              )}
              {select && (
                <div className="client-id">
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      font: "200%",
                      marginBottom: "5%",
                    }}
                  >
                    กรอกเลขประจำตัวพนักงาน
                  </div>
                  <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                    <TextField
                      value={emp_code}
                      onChange={(e) => setEmp_Code(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.charCode == 13) {
                          searchAPI();
                        }
                      }}
                      disabled={!doc}
                      className="select_id"
                      variant="outlined"
                      style={{ width: 90 }}
                      inputProps={{ maxLength: 13 }}
                      fullWidth
                    />
                  </div>
                </div>
              )}
              {/* Search Button */}
              <div className="print">
                <Button
                  disabled={!emp_code || loading}
                  variant="contained"
                  style={{
                    backgroundColor: !emp_code ? "#fff" : "grey",
                    width: "50%",
                    height: "100%",
                    alignItems: "start",
                    textTransform: "none",
                  }}
                  onClick={searchAPI}
                >
                  Search
                </Button>
              </div>
              {/* Print Button */}
              {data && (
                <div className="print">
                  <Button
                    disabled={loading}
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(90, 175, 57)",
                      width: "80%",
                      height: "100%",
                      textTransform: "none",
                    }}
                    onClick={print}
                  >
                    Print
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="doc_size" style={{ width: "70%" }}>
            {data && SelectDocs}
          </div>
        </div>
      </div>
    </>
  );
};
export default Export_Docs;
